import { z } from "zod";
import { createRoute } from "@tanstack/react-router";
import { AuditLog } from "./AuditLog";
import { AccountConfigurations } from "./Configurations";
import { APIKeys } from "./APIKeys";
import { APIKey } from "./APIKey";
import { AccountMembers } from "./Members";
import { Billing, billingTabSchema } from "./Billing";
import { accountDashboardLayoutRoute } from "../../../App";
import { Usage } from "./Usage";

const accountRoute = createRoute({
  getParentRoute: () => accountDashboardLayoutRoute,
  path: "/admin",
});

const accountMembersRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "/members",
  component: AccountMembers,
});

export const accountBillingRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "/billing",
  component: Billing,
  validateSearch: z.object({
    tab: billingTabSchema,
  }).default({ tab: "payments" }),
});

export const accountUsageRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "/usage",
  component: Usage,
});

const accountAuditRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "/audit-log",
  component: AuditLog,
});

const accountConfigurationsRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "/configurations",
  component: AccountConfigurations,
});

const accountApiKeysRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "/api-keys",
  component: APIKeys,
});

const accountNewApiKeyRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "/new-api-key",
  component: APIKey,
});

const editApiKeyRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "/edit-api-key/$id",
  component: APIKey,
});

export const accountsRoutes = accountRoute.addChildren([
  accountMembersRoute,
  accountBillingRoute,
  accountUsageRoute,
  accountAuditRoute,
  accountConfigurationsRoute,
  accountApiKeysRoute,
  accountNewApiKeyRoute,
  editApiKeyRoute,
]);
